import { render, staticRenderFns } from "./AccreditationPrintPass_principality.vue?vue&type=template&id=f36fe7a2&scoped=true"
import script from "./AccreditationPrintPass_principality.vue?vue&type=script&lang=js"
export * from "./AccreditationPrintPass_principality.vue?vue&type=script&lang=js"
import style0 from "./AccreditationPrintPass_principality.vue?vue&type=style&index=0&id=f36fe7a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f36fe7a2",
  null
  
)

export default component.exports